// Font sizes
export const DEFAULT_FONT_SIZE = 14;

export const FONT_SIZES = [8, 9, 10, 11, 12, 14, 18, 24, 30, 36, 48, 60, 72, 96];

// A list of supported fonts
export const FONTS = [
    {
        name: 'Arial',
        fontFamily: 'Arial, Helvetica, sans-serif',
    },
    {
        name: 'Courier New',
        fontFamily: "'Courier New', Courier, monospace",
    },
    {
        name: 'Georgia',
        fontFamily: 'Georgia, serif',
    },
    {
        name: 'Merriweather',
        fontFamily: "'Merriweather', 'Times', serif",
    },
    {
        name: 'Open Sans',
        fontFamily: "'Open Sans', sans-serif",
    },
    {
        name: 'Roboto',
        fontFamily: "'Roboto', sans-serif",
    },
    {
        name: 'Times New Roman',
        fontFamily: "'Times New Roman', Times, serif",
    },
    {
        name: 'Verdana',
        fontFamily: 'Verdana, Geneva, sans-serif',
    },
];

export const DEFAULT_FONT_INDEX = 0;
export const DEFAULT_FONT = FONTS[DEFAULT_FONT_INDEX];

export const RichTextEditorOptions = {
    DefaultFontSize: `${DEFAULT_FONT_SIZE}px`,
    DefaultFontFamily: DEFAULT_FONT.fontFamily,
};
